<button type="button" #ttoColumnSelectButton command="show-modal" commandfor="ttoColumnSelectDialog"
    class="inline-flex items-center gap-x-1.5 btn-shout btn-shout-xs btn-shout-primary">
    Select Columns
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
        stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="-mr-0.5 size-5">
        <rect width="7" height="13" x="3" y="8" rx="1" />
        <path d="m15 2-3 3-3-3" />
        <rect width="7" height="13" x="14" y="8" rx="1" />
    </svg>
</button>

<el-dialog>
    <dialog #ttoColumnSelectDialog id="ttoColumnSelectDialog" aria-labelledby="ttoColumnSelectDialog-title"
        class="fixed inset-0 size-auto max-h-none max-w-none overflow-hidden bg-transparent backdrop:bg-transparent">

        <el-dialog-backdrop (click)="closeDrawer()"
            class="fixed inset-0 z-10 w-dvw overflow-hidden green-noise-bg opacity-100 transition-opacity ease-in-out data-closed:opacity-0 data-enter:duration-300 data-leave:duration-200">
        </el-dialog-backdrop>

        <div tabindex="0" class="absolute inset-0 pl-10 focus:outline-none sm:pl-16 z-20"
            (click)="$event.stopPropagation()">
            <el-dialog-panel
                class="ml-auto block size-full max-w-md transform transition-transform ease-in-out data-closed:translate-x-full data-enter:duration-300 data-leave:duration-200 p-4"
                (click)="$event.stopPropagation()">
                <div class="relative flex h-full flex-col overflow-y-auto shadow-xl rounded-xl ">

                    <div class="h-full flex flex-col overflow-hidden divide-y divide-border">
                        <!-- header -->
                        <div class="px-2 py-4 drawer-header-primary" style="padding-bottom: 0 !important;">
                            <div class="w-full flex flex-col items-start justify-center space-y-2 ">
                                <div class="flex space-x-3 h-full items-start w-full">
                                    <div class="min-w-0 flex-1 px-2">
                                        <p class="text-md font-semibold text-primary">
                                            Select Columns
                                        </p>
                                        <p class="text-sm text-secondary">
                                            Select the columns you want to display.
                                        </p>
                                    </div>

                                    <div class="h-full flex flex-col justify-between items-end">

                                        <button type="button" (click)="closeDrawer()"
                                            class="btn-fab-secondary text-secondary">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round" class="size-5">
                                                <path d="M18 6 6 18" />
                                                <path d="m6 6 12 12" />
                                            </svg>
                                        </button>

                                    </div>
                                </div>

                                <!-- Tabs Nav -->
                                <div class="w-full flex items-center">
                                    <nav aria-label="Tabs"
                                        class="flex flex-row w-full justify-center space-x-6 cursor-pointer">

                                        <a (click)="setTab('engagement')" aria-current="page"
                                            class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                            [class]="getTabClass('engagement')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                                [class]="getSelectedTabIconClass('engagement') + (selectedTab() === 'engagement' ? ' mr-1.5' : '')">
                                                <path
                                                    d="m14.479 19.374-.971.939a2 2 0 0 1-3 .019L5 15c-1.5-1.5-3-3.2-3-5.5a5.5 5.5 0 0 1 9.591-3.676.56.56 0 0 0 .818 0A5.49 5.49 0 0 1 22 9.5a5.2 5.2 0 0 1-.219 1.49" />
                                                <path d="M15 15h6" />
                                                <path d="M18 12v6" />
                                            </svg>
                                            <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                                [class]="selectedTab() === 'engagement' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                                Engagement
                                            </span>
                                        </a>

                                        <a (click)="setTab('content-performance')" aria-current="page"
                                            class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                            [class]="getTabClass('content-performance')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                                [class]="getSelectedTabIconClass('content-performance') + (selectedTab() === 'content-performance' ? ' mr-1.5' : '')">
                                                <path d="M3 3v16a2 2 0 0 0 2 2h16" />
                                                <path d="m19 9-5 5-4-4-3 3" />
                                            </svg>
                                            <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                                [class]="selectedTab() === 'content-performance' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                                Content Performance
                                            </span>
                                        </a>

                                        <a (click)="setTab('ads-performance')" aria-current="page"
                                            class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                            [class]="getTabClass('ads-performance')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                                [class]="getSelectedTabIconClass('ads-performance') + (selectedTab() === 'ads-performance' ? ' mr-1.5' : '')">
                                                <path d="M12 16v5" />
                                                <path d="M16 14v7" />
                                                <path d="M20 10v11" />
                                                <path
                                                    d="m22 3-8.646 8.646a.5.5 0 0 1-.708 0L9.354 8.354a.5.5 0 0 0-.707 0L2 15" />
                                                <path d="M4 18v3" />
                                                <path d="M8 14v7" />
                                            </svg>

                                            <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                                [class]="selectedTab() === 'ads-performance' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                                Ads Performance
                                            </span>
                                        </a>

                                        <a (click)="setTab('audience')" aria-current="page"
                                            class="group inline-flex items-center border-b-2 px-1 py-2.5 text-sm font-medium transition-all duration-200 ease-in-out overflow-hidden"
                                            [class]="getTabClass('audience')">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="size-4 shrink-0 transition-all duration-200 ease-in-out group-hover:mr-1.5"
                                                [class]="getSelectedTabIconClass('audience') + (selectedTab() === 'audience' ? ' mr-1.5' : '')">
                                                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                                                <path d="M16 3.128a4 4 0 0 1 0 7.744" />
                                                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                                                <circle cx="9" cy="7" r="4" />
                                            </svg>

                                            <span class="transition-all duration-200 ease-in-out whitespace-nowrap"
                                                [class]="selectedTab() === 'audience' ? 'opacity-100 max-w-xs' : 'opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-xs'">
                                                Audience
                                            </span>
                                        </a>

                                    </nav>
                                </div>
                                <!-- Tabs Nav - END -->
                            </div>
                        </div>
                        <!-- header - END -->

                        <!-- main content -->
                        <div
                            class="relative h-full flex-1 flex-col items-center justify-center w-full overflow-y-auto drawer-body-primary divide-y divide-border scrollbar-transparent">

                            @switch (selectedTab()) {
                            @case ('engagement') {
                            @for (col of engagementCols; track col.key) {
                            <label
                                class="flex items-center gap-x-3 px-4 py-3 cursor-pointer hover:bg-[--surface-hover] w-full">
                                <input type="checkbox" [checked]="isChecked(col.key)" (change)="toggleColumn(col.key)"
                                    class="size-4 rounded border-[--border] text-[--primary] accent-[--primary] cursor-pointer">
                                <span class="text-sm text-primary">{{ col.label }}</span>
                            </label>
                            }
                            }
                            @case ('content-performance') {
                            @for (col of contentPerformanceCols; track col.key) {
                            <label
                                class="flex items-center gap-x-3 px-4 py-3 cursor-pointer hover:bg-[--surface-hover] w-full">
                                <input type="checkbox" [checked]="isChecked(col.key)" (change)="toggleColumn(col.key)"
                                    class="size-4 rounded border-[--border] text-[--primary] accent-[--primary] cursor-pointer">
                                <span class="text-sm text-primary">{{ col.label }}</span>
                            </label>
                            }
                            }
                            @case ('ads-performance') {
                            @for (col of adsPerformanceCols; track col.key) {
                            <label
                                class="flex items-center gap-x-3 px-4 py-3 cursor-pointer hover:bg-[--surface-hover] w-full">
                                <input type="checkbox" [checked]="isChecked(col.key)" (change)="toggleColumn(col.key)"
                                    class="size-4 rounded border-[--border] text-[--primary] accent-[--primary] cursor-pointer">
                                <span class="text-sm text-primary">{{ col.label }}</span>
                            </label>
                            }
                            }
                            @case ('audience') {
                            @for (col of audienceCols; track col.key) {
                            <label
                                class="flex items-center gap-x-3 px-4 py-3 cursor-pointer hover:bg-[--surface-hover] w-full">
                                <input type="checkbox" [checked]="isChecked(col.key)" (change)="toggleColumn(col.key)"
                                    class="size-4 rounded border-[--border] text-[--primary] accent-[--primary] cursor-pointer">
                                <span class="text-sm text-primary">{{ col.label }}</span>
                            </label>
                            }
                            }
                            }

                        </div>
                        <!-- main content - END -->

                        <!-- filter content -->
                        <div class="px-2 py-2 drawer-header-primary">
                            <div class="flex flex-row items-center justify-between">

                                <button type="button" (click)="clear()"
                                    class="secondary-button rounded-full px-2.5 py-1 text-xs font-semibold text-primary">Clear</button>

                                <button type="button" (click)="apply()"
                                    class="inline-flex items-center gap-x-1.5 primary-button">
                                    Apply
                                    <svg viewBox="0 0 20 20" fill="currentColor" data-slot="icon" aria-hidden="true"
                                        class="-mr-0.5 size-5">
                                        <path
                                            d="M10 18a8 8 0 1 0 0-16 8 8 0 0 0 0 16Zm3.857-9.809a.75.75 0 0 0-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 1 0-1.06 1.061l2.5 2.5a.75.75 0 0 0 1.137-.089l4-5.5Z"
                                            clip-rule="evenodd" fill-rule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                        </div>
                        <!-- filter content - END -->
                    </div>

                </div>
            </el-dialog-panel>

        </div>
    </dialog>
</el-dialog>